<template>
    <div class="table-responsive">
        <table class="table table-bordered table-striped table-hover">
            <thead>
            <tr>
                <th>
                    #
                </th>
                <th>
                    {{$t('Module Name')}}
                </th>
                <th>
                    {{$t('Status')}}
                </th>
                <th>
                    {{$t('Actions')}}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(value, key, index) in moduleData.data.enabled" v-bind:key="key">
                <th scope="row">
                    {{index+1}}
                </th>
                <td>
                    {{key}}
                </td>
                <td>
                    {{$t('Active')}}
                </td>
                <td>
                    <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{$t('Actions')}}
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <router-link class="dropdown-item" :to="'/admin/modules/update-entity/' + key">
                                {{$t('Update Entity')}}
                            </router-link>
                            <div class="dropdown-divider"></div>
                            <router-link class="dropdown-item" :to="'/admin/modules/update-middleware/' + key">
                                {{$t('Update Middlewares')}}
                            </router-link>
                            <router-link class="dropdown-item" :to="'/admin/modules/update-prefix/' + key">
                                {{$t('Update Prefix')}}
                            </router-link>
                            <div class="dropdown-divider"></div>
                            <router-link class="dropdown-item" :to="'/admin/modules/update-validation/' + key">
                                {{$t('Update Validation')}}
                            </router-link>
                            <router-link class="dropdown-item" :to="'/admin/modules/update-resource/' + key">
                                {{$t('Update Resources')}}
                            </router-link>
                            <div class="dropdown-divider"></div>
                            <router-link class="dropdown-item" :to="'/admin/modules/update-inputs/' + key">
                                {{$t('Update Inputs')}}
                            </router-link>
                        </div>
                    </div>
                </td>
            </tr>
            <tr v-for="(value, key, index) in moduleData.data.disabled" v-bind:key="key">
                <th scope="row">
                    {{index+1}}
                </th>
                <td>
                    {{key}}
                </td>
                <td>
                    {{$t('Disabled')}}
                </td>
                <td>
                    -
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
  name: 'ModuleList',
  data () {
    return {
      moduleData: {
        data: {
          enabled: {},
          disabled: {}
        }
      }
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('ModuleList'))

    let self = this
    this.$http
      .get(process.env.API_URL + '/api/v1/admin/module-builder/index', {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.moduleData = res.data
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/module/ModuleList.vue